<template>
  <div class="eventos-destacados-swiper-root">
    <div
      ref="swiperEl"
      class="swiper eventos-destacados-swiper"
    >
      <div class="swiper-wrapper">
        <div
          v-for="item in events"
          :key="'dest-sw-' + item.id"
          class="swiper-slide"
        >
          <div class="swiper-slide-inner">
            <EventoCard
              :val="item"
              :pasado="pasado"
              flat-card
              @showBanner="$emit('showBanner', $event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      ref="prevEl"
      class="swiper-button-prev ed-nav ed-nav--prev"
      role="button"
      aria-label="Anterior"
    />
    <div
      ref="nextEl"
      class="swiper-button-next ed-nav ed-nav--next"
      role="button"
      aria-label="Siguiente"
    />
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.esm.js'
import 'swiper/swiper-bundle.min.css'
import EventoCard from '@/components/EventoCard.vue'

export default {
  name: 'EventosDestacadosCarousel',
  components: { EventoCard },
  props: {
    events: {
      type: Array,
      required: true
    },
    pasado: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: null
    }
  },
  watch: {
    events: {
      deep: true,
      handler() {
        this.$nextTick(() => this.reconcileSwiper())
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.initSwiper())
  },
  beforeDestroy() {
    this.destroySwiper()
  },
  methods: {
    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true)
        this.swiper = null
      }
    },
    initSwiper() {
      this.destroySwiper()
      const el = this.$refs.swiperEl
      if (!el || !this.events || this.events.length === 0) {
        return
      }
      this.swiper = new Swiper(el, {
        // Móvil (viewport menor a breakpoint 600): menos ancho por slide para no estirar la card
        slidesPerView: 1.2,
        spaceBetween: 14,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resistanceRatio: 0.75,
        breakpoints: {
          600: {
            slidesPerView: 2.5,
            spaceBetween: 16
          },
          960: {
            slidesPerView: 3.5,
            spaceBetween: 18
          }
        },
        navigation: {
          prevEl: this.$refs.prevEl,
          nextEl: this.$refs.nextEl
        }
      })
    },
    reconcileSwiper() {
      if (!this.events || this.events.length === 0) {
        this.destroySwiper()
        return
      }
      if (this.swiper) {
        this.swiper.update()
        this.swiper.slideTo(0, 0)
      } else {
        this.initSwiper()
      }
    }
  }
}
</script>

<style scoped>
.eventos-destacados-swiper-root {
  position: relative;
  padding: 0 !important;
  margin: 0 -4px;
}

.eventos-destacados-swiper {
  overflow: hidden;
  width: 100%;
  box-shadow: none;
  background: transparent;
}

.swiper-slide-inner {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.swiper-slide-inner >>> .evento-card {
  width: 100%;
  max-width: 100%;
}

/* Flechas: sin caja sombreada del theme por defecto */
.ed-nav {
  color: #ff4900;
  width: 36px;
  height: 36px;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: none;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  border: 1px solid #e0e0e0;
}

.ed-nav::after {
  font-size: 18px;
  font-weight: bold;
}

.ed-nav--prev {
  left: 2px;
}

.ed-nav--next {
  right: 2px;
}

@media (max-width: 599px) {
  .eventos-destacados-swiper-root {
    padding-left: 32px;
    padding-right: 32px;
  }
}
</style>
